import Dashboard from '@/views/users/Dashboard'
import SettingsUser from '@/views/users/settings/User'
import SettingsSchool from '@/views/users/settings/School'
import SettingsTeam from '@/views/users/settings/Team'
import CompetitionDetails from '@/views/users/competitions/Details'
import CompetitionRegistration from '@/views/users/competitions/Registration'

export default [
  {
    path: '/dashboard',
    name: 'teacher.dashboard',
    component: Dashboard,
    meta: {
      authRequired: true,
      requiredRole: 1
    }
  },
  {
    path: '/settings/me',
    name: 'teacher.settings.user',
    component: SettingsUser,
    meta: {
      authRequired: true,
      requiredRole: 1
    }
  },
  {
    path: '/settings/school',
    name: 'teacher.settings.school',
    component: SettingsSchool,
    meta: {
      authRequired: true,
      requiredRole: 1
    }
  },
  {
    path: '/settings/team',
    name: 'teacher.settings.team',
    component: SettingsTeam,
    meta: {
      authRequired: true,
      requiredRole: 1
    }
  },
  {
    path: '/school/competitions/:id/',
    name: 'teacher.competition.details',
    component: CompetitionDetails,
    meta: {
      authRequired: true,
      requiredRole: 1
    }
  },
  {
    path: '/school/competitions/:id/registration',
    name: 'teacher.competition.registration',
    component: CompetitionRegistration,
    meta: {
      authRequired: true,
      requiredRole: 1
    }
  }
]



//////////////////
// WEBPACK FOOTER
// ./src/router/routes.users.js
// module id = 914
// module chunks = 1